const tabComponents = document.querySelectorAll('.tab-component');

if (tabComponents.length > 0) {
  tabComponents.forEach(tabComponent => {
    const buttons = tabComponent.querySelectorAll('.tab-component__btn');
    const contents = tabComponent.querySelectorAll('.tab-component__content');

    if (buttons.length > 0 && contents.length > 0) {
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const tab = button.getAttribute('data-tab');
          const targetContent = tabComponent.querySelector(`.tab-component__content[data-content="${tab}"]`);

          if (!targetContent) return;

          buttons.forEach(btn => btn.classList.remove('active'));
          contents.forEach(content => content.classList.remove('active'));

          button.classList.add('active');
          targetContent.classList.add('active');
        });
      });
    }
  });
}
